import { useContext, useEffect } from "react";
import TitleContext from "../context/TitleContext";
import UpdateBankAccountForm from "../components/banks/UpdateBankAccount";
const UpdateBankAccountPage = () => {
  const { setTitle } = useContext(TitleContext);

  useEffect(() => {
    setTitle("Update Bank Account");
  }, [setTitle]);
  return (
    <>
      <UpdateBankAccountForm />
    </>
  );
};
export default UpdateBankAccountPage;
